import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import Neovis from "neovis.js/dist/neovis.js";
import { Alert } from "@mui/material";

const NeoGraph = (props) => {
  const {
    width,
    height,
    containerId,
    backgroundColor,
    neo4jUri,
    neo4jUser,
    neo4jPassword,
    cypher,
    alertWidth,
  } = props;

  const visRef = useRef();

  useEffect(() => {
    const config = {
      container_id: visRef.current.id,
      server_url: neo4jUri,
      server_user: neo4jUser,
      server_password: neo4jPassword,
      labels: {
        Gene: {
          caption: "name",
        },
        Disease: {
          caption: "name",
        },
        Compound: {
          caption: "name",
        },
        Drug: {
          caption: "name",
        },
        DrugCombo: {
          caption: "name",
        },
        LiverToxicity: {
          caption: "FDA_LTKB_ID",
        },
        Event: {
          caption: "name",
        },
        Source: {
          caption: "name",
        },
        Host: {
          caption: "name",
        },
        Service: {
          caption: "name",
        },
        Protocol: {
          caption: "name",
        },
        Logs: {
          caption: "name",
        },
        Attack_Type: {
          caption: "name",
        },
      },
      relationships: {
        Relation: {
          caption: true,
        },
      },
      initial_cypher: cypher,
      encrypted: "ENCRYPTION_ON",
      trust: "TRUST_SYSTEM_CA_SIGNED_CERTIFICATES",
    };
    const vis = new Neovis(config);
    vis.render();
  }, [neo4jUri, neo4jUser, neo4jPassword, cypher]);

  return (
    <>
      <div
        id={containerId}
        ref={visRef}
        style={{
          width: `${width}px`,
          height: `${height}px`,
          backgroundColor: `${backgroundColor}`,
        }}
      />
      {alertWidth && (
        <Alert
          severity="info"
          sx={{
            fontSize: "12px",
            position: "absolute",
            bottom: 0,
            width: "97.5%",
          }}
        >
          This displays only 100 relations
        </Alert>
      )}
    </>
  );
};

NeoGraph.defaultProps = {
  width: 600,
  height: 600,
  backgroundColor: "#d3d3d3",
};

NeoGraph.propTypes = {
  containerId: PropTypes.string.isRequired,
  neo4jUri: PropTypes.string.isRequired,
  neo4jUser: PropTypes.string.isRequired,
  neo4jPassword: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string,
  cypher: PropTypes.string,
  alertWidth: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};

export { NeoGraph };
